// extracted by mini-css-extract-plugin
module.exports = {"uploadInput":"style_uploadInput__1MHRO","inputCol":"style_inputCol__HIoFf","buttonCol":"style_buttonCol__1nOK8"};